import DigitalSign from './ui';

export default DigitalSign;